<template>
  <div>
    <q-select
      outlined
      v-model="selectedMonthOfWeather"
      :options="months"
      label="Month"
      clearable
      @clear="clearSelectedTempObjs"
      hint="USA Only"
    >
      <template v-slot:prepend>
        <q-icon name="event"></q-icon>
      </template>
    </q-select>
    <div v-if="hasValidMonthIndex" class="q-pt-md">
      <q-checkbox
        v-for="tempRangeObj in TEMP_RANGES"
        :key="tempRangeObj.id"
        v-model="selectedTempObjs"
        :val="tempRangeObj.id"
        :label="
          `${tempRangeObj.label} (${tempRangeObj.tempRange[0]}° to ${tempRangeObj.tempRange[1]}°)`
        "
        :color="tempRangeObj.color"
        keep-color
      />
    </div>
  </div>
</template>
<script>
const TEMP_RANGES = [
  {
    id: "tempRange0",
    label: "Very Cold",
    tempRange: [0, 40],
    color: "blue-10",
  },
  {
    id: "tempRange1",
    label: "Cold",
    tempRange: [40, 55],
    color: "light-blue-6",
  },
  {
    id: "tempRange2",
    label: "Cool",
    tempRange: [55, 65],
    color: "cyan-3",
  },
  {
    id: "tempRange3",
    label: "Comfortable",
    tempRange: [65, 75],
    color: "yellow-8",
  },
  {
    id: "tempRange4",
    label: "Warm",
    tempRange: [75, 85],
    color: "orange-7",
  },
  {
    id: "tempRange5",
    label: "Hot",
    tempRange: [85, 100],
    color: "red-6",
  },
  // As of 2022, no courses matched this range...yet
  // {
  //   id: "tempRange6",
  //   label: "Very Hot",
  //   tempRange: [100, 120],
  //   color: "red-10",
  // },
];

export default {
  name: "WeatherFilter",
  props: {
    weatherFilterInput: {
      required: true,
    },
  },
  data() {
    return {
      loading: false,
      months: Array.from({ length: 12 }, (x, index) =>
        new Date(0, index).toLocaleDateString("en-US", { month: "long" }),
      ),
      monthsShort: Array.from({ length: 12 }, (x, index) =>
        new Date(0, index).toLocaleDateString("en-US", { month: "short" }),
      ),
      selectedMonthOfWeather: null,
      selectedTempObjs: [],
    };
  },
  beforeCreate() {
    this.TEMP_RANGES = TEMP_RANGES;
  },
  mounted() {
    this.$root.$on("reset-filter-input", () => {
      console.debug("reset-filter-input in weather");

      this.reset();
    });
  },
  computed: {
    monthIndex() {
      return this.months.indexOf(this.selectedMonthOfWeather);
    },
    hasValidMonthIndex() {
      return this.selectedMonthOfWeather !== null;
    },
    matchedRanges() {
      return this.TEMP_RANGES.filter(range =>
        this.selectedTempObjs.includes(range.id),
      );
    },
    completedFilter() {
      if (this.monthIndex === -1) {
        return null;
      }

      if (!this.matchedRanges.length) {
        return null;
      }

      const monthIndex = this.monthIndex;
      const matchedRanges = this.matchedRanges;
      const shortMonth = this.monthsShort[monthIndex].toLowerCase();
      const matchedRangeIds = matchedRanges.map(mr => mr.id);
      const rangePairs = matchedRanges.map(mr => {
        const low = mr.tempRange[0];
        const high = mr.tempRange[1];

        return [low, high];
      });
      const queryStringRangePairs = rangePairs
        .map(rp => rp.join("-"))
        .join(",");

      return {
        monthIndex,
        matchedRanges,
        matchedRangeIds,
        shortMonth,
        queryStringRangePairs,
      };
    },
  },
  beforeDestroy() {
    this.$root.$off("reset-filter-input");
  },
  methods: {
    clearSelectedTempObjs() {
      this.selectedTempObjs = [];
    },
    reset() {
      this.selectedMonthOfWeather = null;
      this.clearSelectedTempObjs();
    },
  },
  watch: {
    weatherFilterInput: {
      handler(newVal, oldVal) {
        // need to re-hydrate
        if (this.monthIndex === -1 && newVal && !oldVal) {
          const month = this.months[newVal.monthIndex];
          const rangeIds = newVal.matchedRanges.map(mr => mr.id);

          this.selectedMonthOfWeather = month;
          this.selectedTempObjs = rangeIds;
        }

        if (newVal === "reset") {
          this.reset();
        }
      },
      immediate: true,
    },
    completedFilter(newVal) {
      this.$emit("update", newVal);
    },
  },
};
</script>
<style lang="scss" scoped></style>
